// extracted by mini-css-extract-plugin
export var actionButton = "_7s-0";
export var attachmentLine = "_7s-1";
export var fileInput = "_7s-2";
export var fileUploadWrapper = "_7s-4";
export var footer = "_7s-3";
export var modalContent = "_7s-5";
export var paperclip = "_7s-6";
export var quillEditor = "_7s-7";